import React, { useState, useEffect } from "react";
import { XCircle, CaretLeft } from "phosphor-react";
import Select from "../../../Components/forms/SearchableDropdown";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SearchableDropdown from "../../../Components/forms/SearchableDropdown";


function ExpensesUpdate(props) {
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const toDateInputValue = (value) => {
    if (!value) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    const match = String(value).match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
  };

  const toApiDateValue = (value) => {
    const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return match ? `${match[3]}-${match[2]}-${match[1]}` : value;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const file = event.dataTransfer.files[0];
    setSelectedFile(file);
  };

  const handleCancleClick = () => {
    props.handleCancel();
  };
  const jwtToken = localStorage.getItem("jwtToken");

  const expenseAccount = [
    { value: "Cost of Goods Sold", label: "Cost of Goods Sold" },
    { value: "Job Costing", label: "Job Costing" },
    { value: "Labor", label: "Labor" },
    { value: "Materials", label: "Materials" },
    { value: "Subcontractor", label: "Subcontractor" },
    { value: "Addance Tax", label: "Addance Tax" },
    { value: "Employee Advance", label: "Employee Advance" },
    { value: "Input Tax Credit", label: "Input Tax Credit" },
    { value: "Input CSGT", label: "- Input CSGT" },
    { value: "Input IGST", label: "- Input IGST" },
    { value: "Input SGST", label: "- Input SGST" },
    { value: "Prepaid Expenses", label: "Prepaid Expenses" },
    {
      value: "Reverse charge tax input but not due",
      label: "Reverse charge tax input but not due",
    },
    { value: "TDS receivable", label: "TDS receivable" },
    { value: "Furniture and quipment", label: "Furniture and quipment" },
    { value: "Employee Reimbursement", label: "Employee Reimbursement" },
    { value: "GST payable", label: "GST payable" },
    { value: "Output CGST", label: "- Output CGST" },
    { value: "Output IGST", label: "- Output IGST" },
    { value: "Output SGST", label: "- Output SGST" },
    { value: "Opening Balance Adjusment", label: "GOpening Balance Adjusment" },
    { value: "Tax payable", label: "Tax payable" },
    { value: "TDS payable", label: "TDS payable" },
    { value: "Unearned revenue", label: "Unearned revenue" },
    { value: "Advertising and marketing", label: "Advertising and marketing" },
    { value: "Automobile expense", label: "Automobile expense" },
    { value: "Bad debt", label: "Bad debt" },
    { value: "Bank fees and charges", label: "Bank fees and charges" },
    { value: "Consultant Expense", label: "Consultant Expense" },
    { value: "Contract assets", label: "Contract assets" },
    { value: "Credit card charges", label: "Credit card charges" },
    {
      value: "Depreciation and amortisation",
      label: "Depreciation and amortisation",
    },
    { value: "Depreciation expense", label: "Depreciation expense" },
    { value: "IT and Internet expenses", label: "IT and Internet expenses" },
    { value: "Janitorial expense", label: "Janitorial expense" },
    { value: "Lodging", label: "Lodging" },
    { value: "Meals and entertainment", label: "Meals and entertainment" },
    { value: "Merchandise", label: "Merchandise" },
    { value: "Office Supplies", label: "Office Supplies" },
    { value: "Other expenses", label: "Other expenses" },
    { value: "Postage", label: "Postage" },
    { value: "Printing Stationery", label: "Printing Stationery" },
    {
      value: "Raw materials and consumables",
      label: "Raw materials and consumables",
    },
    { value: "Rent expense", label: "Rent expense" },
    { value: "Repairs and maintainance", label: "Repairs and maintainance" },
    {
      value: "Salareis and employee wages",
      label: "Salareis and employee wages",
    },
    { value: "Telephone expense", label: "Telephone expense" },
    { value: "Transportation expense", label: "Transportation expense" },
    { value: "Travel expense", label: "Travel expense" },
    { value: "Uncategorized", label: "Uncategorized" },
  ];

  const paidThrough = [
    { value: "Bank account", label: "bank account" },
    { value: "Invoice", label: "Invoice" },
    { value: "Petty Cash", label: "Petty Cash" },
    { value: "Undeposited funds", label: "Undeposited funds" },
    { value: "Advance Tax", label: "Advance Tax" },
    { value: "Employee Advance", label: "Employee Advance" },
    { value: "Prepaid Expenses", label: "Prepaid Expenses" },
    { value: "TDS Receivables", label: "TDS Receivables" },
    { value: "Employee reimbursements", label: "Employee reimbursements" },
    {
      value: "Opening balance adjustment",
      label: "Opening balance adjustment",
    },
    { value: "TDS payable", label: "TDS payable" },
  ];

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [custNames, setCustNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(""); // State to store the selected customer's ID
  const [vendorNames, setVendorNames] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedExpenseAccount, setSelectedExpenseAccount] = useState("");
  const [selectedPaidThrough, setSelectedPaidThrough] = useState("");
  const [loading, setLoading] = useState(true);
  const [expenses, setExpenses] = useState({});
  const [expId, setExpense] = useState([]);

  const [serverData, setServerData] = useState({
    date: "",
    expenseAccount: "", // Initialize to an empty string
    amount: "",
    paidThrough: "", // Initialize to an empty string
    vendor: "",
    invoice: "",
    notes: "",
    customerName: "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setServerData({
      ...serverData,
      [name]: value,
    });
  };
  const { expenseId } = props;

  useEffect(() => {
    // Get the encrypted uniqueId from session storage
    const encryptedUniqueId = localStorage.getItem("uniqueId1");

    // Decrypt the uniqueId using your decryption method
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    // Fetch invoices for the decrypted uniqueId
    fetch(BASE_URL + `/fetchExpensesById/${expenseId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }), // Send uniqueId in the request body
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const Data = data.responseMessage;
          const ExpId = Data.id;
          setImage(
            Data.attachReceipt
              ? `https://app.zeroserp.in/expense_images/${Data.attachReceipt}`
              : null
          );
          setExpense(ExpId);
          setServerData({
            date: toDateInputValue(Data.date),
            uniqueId: decryptedUniqueId,
            expenseAccount: Data.expenseAccount, // Use selected value from state
            amount: Data.amount,
            paidThrough: Data.paidThrough, // Use selected value from state
            vendor: Data.vendor,
            invoice: Data.invoice,
            notes: Data.notes,
            customerName: Data.customerName,
          });
        } else {
          console.error("Failed to fetch invoices:", data.responseMessage);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        setLoading(false);
      });
  }, [expenseId, jwtToken]);
  // Handle the "expenseAccount" selection

  const handleExpenseAccountChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedExpenseAccount(selectedValue);
    setServerData({
      ...serverData,
      expenseAccount: selectedValue,
    });
  };

  // Handle the "paidThrough" selection
  const handlePaidThroughChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedPaidThrough(selectedValue);
    setServerData({
      ...serverData,
      paidThrough: selectedValue,
    });
  };

  const handleSaveClick = async () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");

    // Decrypt the uniqueId using your decryption method
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const titleAndDescriptionData = {
      date: toApiDateValue(serverData.date),
      uniqueId: decryptedUniqueId,
      expenseAccount: serverData.expenseAccount, // Use selected value from state
      amount: serverData.amount,
      paidThrough: serverData.paidThrough, // Use selected value from state
      vendor: serverData.vendor,
      customerName: serverData.customerName,
      invoice: serverData.invoice,
      notes: serverData.notes,
    };

    try {
      const formData = new FormData();
      Object.keys(titleAndDescriptionData).forEach((key) => {
        formData.append(key, titleAndDescriptionData[key]);
      });
      // Existing receipts stay on the expense. Only send an image when the user
      // explicitly selects a replacement; downloading the old remote image here
      // caused CORS failures and prevented otherwise valid edits from saving.
      if (selectedFile) formData.append("image", selectedFile);

      const response = await fetch(`${BASE_URL}/updateExpenses/${expId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: formData,
      });
      const data = await response.json();
      if (!response.ok || data.status !== "success") {
        throw new Error(data.responseMessage || "Failed to update expense");
      }

      handleCancleClick();
      swal({ icon: "success", title: "Expense Updated" });
    } catch (error) {
      swal({
        icon: "error",
        title: "Failed to Update Expense",
        text: error.message,
      });
    }
  };

  // Fetch customer data
  useEffect(() => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/getAllCustomerName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setCustNames(data.responseMessage);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  }, []);

  const handleCustomerChange = (event) => {
    const selectedCustomerId = event.target.value;
    setServerData({
      ...serverData,
      customerName: "",
    });
    // Find the selected customer object in the fetched data
    const selectedCustomerObject = custNames.find(
      (person) => String(person.id) === String(selectedCustomerId)
    );

    if (selectedCustomerObject) {
      // Set the selected customer's ID in state
      setSelectedCustomerId(selectedCustomerObject.id);
      setSelectedCustomer(selectedCustomerObject.customerName);
      setServerData({
        ...serverData,
        customerName: selectedCustomerObject.customerName,
      });
    } else {
      setSelectedCustomerId("");
      setSelectedCustomer("");
    }
  };

  useEffect(() => {
    // Get the encrypted uniqueId from session storage
    const encryptedUniqueId = localStorage.getItem("uniqueId1");

    // Decrypt the uniqueId using your decryption method
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    // Fetch vendor names for the decrypted uniqueId
    fetch(BASE_URL + `/fetchVendors`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setVendorNames(data.responseMessage);
        } else {
          console.error("Failed to fetch vendor names:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching vendor names:", error);
      });
  }, []);

  const handleVendorChange = (event) => {
    const selectedVendorId = event.target.value;
    setServerData({
      ...serverData,
      vendor: "",
    });
    // Find the selected vendor object based on the display name
    const selectedVendorObject = vendorNames.find(
      (vendor) => String(vendor.id) === String(selectedVendorId)
    );

    if (selectedVendorObject) {
      setSelectedVendorId(selectedVendorObject.id);
      setSelectedVendor(selectedVendorObject.vendorDisplayName);
      setServerData({
        ...serverData,
        vendor: selectedVendorObject.vendorDisplayName,
      });
    } else {
      setSelectedVendorId("");
      setSelectedVendor("");
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleDateChange = (e) => {
    setCurrentDate(e.target.value);
    setServerData({
      ...serverData,
      date: e.target.value,
    });
  };

  const vendorOptions = vendorNames.map((names) => ({
    label: names.vendorDisplayName,
    value: names.vendorDisplayName,
  }));

  const options = custNames.map((customer) => ({
    value: customer.customerName,
    label: customer.customerName,
  }));

  const [image, setImage] = useState(null);

  const handleDrop1 = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleImage(file);
  };

  const handleImageInputChange = (e) => {
    const file = e.target.files[0];
    handleImage(file);
  };

  const handleImage = (file) => {
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setSelectedFile(null);
  };

  return (
    <>
      <Container fluid className="zarp-premium-form">
        <Row>
          <Col>
            <div className="my-3 mt-4">
              <div className="px-2 d-flex">
                <div
                  className="cursor-pointer d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "50%",
                    height: "35px",
                    width: "38px",
                    cursor: "pointer",
                  }}
                >
                  <ArrowBackIosIcon
                    width={2}
                    onClick={handleCancleClick}
                    className="arrow-child"
                  />
                </div>
                <h4
                  className="mt-1 mx-2 text-primary"
                  style={{ letterSpacing: "1px" }}
                >
                  Update Expense
                </h4>
              </div>
            </div>

            <Card className="card-style">
              <Card.Body>
                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span style={{ color: "red" }}>Date</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <Form.Control
                        className="form-control"
                        value={serverData.date}
                        onChange={handleDateChange}
                        name="date"
                        type="date"
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span style={{ color: "red" }}>Expense Account</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <SearchableDropdown
                        name="expenseAccount"
                        className="form-control"
                        value={selectedExpenseAccount || serverData.expenseAccount}
                        onChange={handleExpenseAccountChange}
                        required
                        style={{ backgroundColor: "#F6F6F6", padding: "5px" }}
                      >
                        <option value="">Select...</option>
                        {expenseAccount.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </SearchableDropdown>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span style={{ color: "red" }}>Amount</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <div>
                        <div className="wrapper" style={{ borderRight: "5px" }}>
                          <Form.Control
                            className=""
                            placeholder="Amount"
                            value={serverData.amount}
                            onChange={handleInputChange}
                            name="amount"
                            type="text"
                            style={{
                              backgroundColor: "#F6F6F6",
                              padding: "12px",
                              borderRadius: "5px",
                            }}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span style={{ color: "red" }}>Paid Through</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <SearchableDropdown
                        name="paidThrough"
                        className="form-control"
                        value={selectedPaidThrough || serverData.paidThrough}
                        onChange={handlePaidThroughChange}
                        style={{ backgroundColor: "#F6F6F6", padding: "5px" }}
                      >
                        <option value="">Select...</option>
                        {paidThrough.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </SearchableDropdown>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span>Vendor</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <SearchableDropdown
                        name="vendorId"
                        className="form-control"
                        value={
                          selectedVendorId ||
                          vendorNames.find(
                            (vendor) =>
                              vendor.vendorDisplayName === serverData.vendor
                          )?.id ||
                          ""
                        }
                        onChange={handleVendorChange}
                        style={{ backgroundColor: "#F6F6F6", padding: "5px" }}
                      >
                        <option value="">Select a Vendor</option>
                        {vendorNames.map((vendor) => (
                          <option key={vendor.id} value={vendor.id}>
                            {vendor.vendorDisplayName}
                          </option>
                        ))}
                      </SearchableDropdown>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span style={{ color: "red" }}>Invoice</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <Form.Control
                        className=""
                        placeholder="Invoive"
                        name="invoice"
                        type="text"
                        value={serverData.invoice}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span>Notes</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <Form.Control
                        className=""
                        placeholder="Notes..."
                        name="notes"
                        value={serverData.notes}
                        onChange={handleInputChange}
                        type="text"
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "12px",
                          borderRadius: "5px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span>Customer Name</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <SearchableDropdown
                        name="customerId"
                        className="form-control"
                        value={
                          selectedCustomerId ||
                          custNames.find(
                            (customer) =>
                              customer.customerName === serverData.customerName
                          )?.id ||
                          ""
                        }
                        onChange={handleCustomerChange}
                        style={{ backgroundColor: "#F6F6F6", padding: "6px" }}
                      >
                        <option value="">Select Customer</option>
                        {custNames.map((customer) => (
                          <option key={customer.id} value={customer.id}>
                            {customer.customerName}
                          </option>
                        ))}
                      </SearchableDropdown>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="2" className="mt-2">
                    <label style={{ fontSize: "14px", color: "grey" }}>
                      <span>Attach Receipt</span>
                    </label>
                  </Col>
                  <Col className="" md="3">
                    <Form.Group>
                      <Col md="3">
                        <div
                          onDrop={handleDrop1}
                          onDragOver={(e) => e.preventDefault()}
                          style={{
                            border: "2px dashed #ccc",
                            borderRadius: "5px",
                            padding: "10px",
                            textAlign: "center",
                            width: "200px",
                            height: "200px",
                            position: "relative",
                            marginRight: "20px", // Added margin for spacing
                          }}
                        >
                          {image ? (
                            <>
                              <img
                                src={image}
                                alt="Uploaded"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  borderRadius: "5px",
                                }}
                              />
                              <button
                                onClick={handleRemoveImage}
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  padding: "5px 10px",
                                  backgroundColor: "red",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                Remove
                              </button>
                            </>
                          ) : (
                            <>
                              <p>Drag & Drop or Click to Browse Image</p>
                              <input
                                type="file"
                                onChange={handleImageInputChange}
                                accept="image/*"
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  left: "0",
                                  width: "100%",
                                  height: "100%",
                                  opacity: "0",
                                  cursor: "pointer",
                                }}
                              />
                            </>
                          )}
                        </div>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <div className="text-right">
                  <button type="button" className="btn-1" onClick={handleCancleClick}>
                    Cancl{" "}
                  </button>
                  <button
                    className="btn-3 btn btn-primary"
                    onClick={handleSaveClick}
                  >
                    Update Expense
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ExpensesUpdate;
